import React from "react";

const InputTextMatPassword = ({
  label,
  onChange,
  id,
  name,
  placeholder,
  value,
  error,
  readOnly = false,
}) => {
  return (
    <>
      <div className="pt-3">
        <div className="border-[1px] relative rounded-[0.3rem] transition-all ease-in-out duration-100 placeholder-text-seondary-color text-text-primary-color border-[#79747E] focus:border-[#79747E] outline-0 font-lato text-[1rem] w-full leading-normal  py-[1rem] px-[1.4rem]">
          <input
            placeholder={placeholder}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
            type="password"
            className="w-full font-normal border-0 outline-0 tracking-[0.5px]"
          />

          <label className="absolute font-normal text-[0.75rem] -translate-y-1/2 -top-[2px] left-4 bg-white px-2 font">
            {label}
          </label>
        </div>
        <label
          htmlFor={id}
          className="font-normal text-[0.75rem] text-red-500 bg-white px-2 my-0 py-0 font"
        >
          {error}
        </label>
      </div>
    </>
  );
};

export default InputTextMatPassword;
